import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetAppraisalModel } from "../../all_Interfaces";



interface InitialState {
    data: GetAppraisalModel ,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: new GetAppraisalModel(),
    error: '',
    loading: false
}

const appraisalSlice = createSlice({
    name: "appraisal",
    initialState,
    reducers: {
        setAppraisal(state, action: PayloadAction<GetAppraisalModel>) {
            state.data = action.payload;
        },
    },
});

export const { setAppraisal } = appraisalSlice.actions;

export default appraisalSlice.reducer;